import React, { useState, useRef, useEffect } from 'react';
import HelpOutlineOutlined from '@mui/icons-material/HelpOutlineOutlined';
import ChatBubbleOutlined from '@mui/icons-material/ChatBubbleOutlined';
import CloseIcon from '@mui/icons-material/Close';
import './HelpWidget.css';

const FAQS = [
  { q: 'How do I create a new report?', a: 'Go to "New Report" in the sidebar, paste or upload the raw report, pick a modality and body part, then convert.' },
  { q: 'What does Pending vs Completed mean?', a: '"Pending" means the report was converted but not yet saved/reviewed. "Completed" means it has been saved and finalized.' },
  { q: 'Can I edit a report after saving it?', a: 'Yes — open the report from "All Reports" and use the edit option before re-saving it.' },
  { q: 'Who can see my reports?', a: 'Only you can see the reports tied to your account. Each report is scoped to the user who created it.' },
  { q: 'How do I report a bug or suggest a feature?', a: 'Add it as feedback under the final report on the report conversion screen — it\'s saved directly with that report.' },
   { q: 'How can I add a new modality or body part?', a: 'New modalities or body parts can be added directly by the administrator through the Admin Panel.' },
];

const HelpWidget = () => {
  const [open, setOpen]       = useState(false);   
  const [faqOpen, setFaqOpen] = useState(false);    
  const wrapRef = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const openFaq = () => { setOpen(false); setFaqOpen(true); };

  return (
    <>
      <div className="help-widget" ref={wrapRef}>
        {open && (
          <div className="help-menu">
            <button className="help-menu-item" onClick={openFaq}>
              <ChatBubbleOutlined sx={{ fontSize: 17 }} />
              <span>FAQ</span>
            </button>
          </div>
        )}
        <button className="help-fab" onClick={() => setOpen(o => !o)}>
          <HelpOutlineOutlined sx={{ fontSize: 18 }} />
          <span>Help Center</span>
        </button>
      </div>

      {faqOpen && (
        <div className="faq-overlay" onClick={() => setFaqOpen(false)}>
          <div className="faq-modal" onClick={(e) => e.stopPropagation()}>
            <div className="faq-header">
              <h2>Frequently Asked Questions</h2>
              <button className="faq-close" onClick={() => setFaqOpen(false)}><CloseIcon sx={{ fontSize: 18 }} /></button>
            </div>
            <div className="faq-body">
              {FAQS.map((f, i) => <FaqItem key={i} q={f.q} a={f.a} />)}
            </div>
            <div className="faq-footer">
              Still stuck? Reach out to the QC team directly.
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const FaqItem = ({ q, a }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className={`faq-item ${open ? 'open' : ''}`}>
      <button className="faq-q" onClick={() => setOpen(o => !o)}>
        <span>{q}</span>
        <span className="faq-chevron">{open ? '−' : '+'}</span>
      </button>
      {open && <div className="faq-a">{a}</div>}
    </div>
  );
};

export default HelpWidget;